import { Dialog } from "@mui/material";
import styled from "styled-components";
import { DARKER, PRIMARY, SECONDARY } from "../../const/colors";
import { mobile_normal } from "../../const/fonts";
import { ButtonSpecial } from "../common/ButtonSpecial";

export const StyledDialog = styled(Dialog)`
  display: none !important;

  @media screen and (max-width: 1080px) {
    display: block !important;
    overflow: hidden;
    z-index: 2000;
  }
`;

export const Container = styled.div.attrs((props) => ({
  className: props.className,
}))`
  background-color: white;
  height: 100vh;
  width: 100vw;
  max-width: 100vw;
  padding-top: calc(65px + 1rem);
  padding-bottom: 2rem;
  overflow: hidden;
  div.btns-mob {
    padding: 0 5%;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1rem;
  }

  @media screen and (max-width: 480px) {
    div.btns-mob {
      margin-bottom: 0.5rem;
    }
  }
`;

export const Menu = styled.ul`
  display: flex;
  flex-direction: column;
  list-style: none;
  width: 100%;
  padding: 0 5%;
`;

export const Item = styled.li.attrs((props) => ({
  className: props.className,
}))`
  position: relative;
  //line-height: 2;

  border-bottom: 1px solid ${DARKER} !important;
  cursor: pointer;
  transition: background-color 0.3s ease;
  outline: none;
  svg {
    color: ${PRIMARY};
    margin-right: 0.5rem;
    width: 20px;
    height: 20px;
    font-size: 20px;
  }
  span {
    color: #fff;
  }

  &.danger {
    background-color: red;
    svg {
      color: #fff;
    }
    border-bottom: none;
  }

  span.badget {
    border-radius: 1rem;
    padding: 0 0.25rem;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0.8rem;
    right: 0.5rem;
    font-weight: normal;
    font-size: 0.6rem;

    svg {
      font-size: 16px;
      margin-right: 0;
      width: 16px;
      height: 16px;
      margin-bottom: 2px;
    }
  }

  span.verificado {
    background-color: #28a745;
    color: #fff;
    svg {
      color: #fff;
    }
  }
  span.sinverificar {
    background-color: transparent;
    border: 1px solid #fff;
    color: #ccc;
    svg {
      color: #ccc;
    }
  }

  &:hover {
    background-color: rgba(0, 0, 0, 0.3);
  }

  span.new {
    position: absolute;
    top: 15px;
    left: 5px;
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background-color: red;
  }

  a,
  button {
    font-size: ${mobile_normal};
    outline: none;
    width: 100%;
    line-height: 2;
    padding: 0.7rem 1rem;
    padding-right: 4rem;
    border: none;
    font-weight: bold;
    text-align: start;
    background-color: transparent;
    color: ${PRIMARY};
    cursor: pointer;
    display: flex;
    align-items: center;
  }
  @media screen and (max-width: 480px) {
    a,
    button {
      line-height: 1.7;
    }
  }

  //telefonos mas pequenos
  @media screen and (max-height: 690px) {
    a,
    button {
      line-height: 1;
    }
    font-size: 0.8rem;
    svg {
      width: 16px;
      height: 16px;
    }
  }
`;

export const ButtonSpecial2 = styled(ButtonSpecial)`
  width: 45%;
  background-color: ${(props) =>
    props.bg === "primary" ? PRIMARY : SECONDARY};
  color: ${(props) => (props.bg === "primary" ? SECONDARY : PRIMARY)};
  border: 1px solid ${PRIMARY};
  font-size: 1rem;
  padding: 0.8rem 1rem;
  font-weight: 600;
  min-width: fit-content;
  transition: all 0.3s ease-in-out;

  &:hover {
    background-color: #fff;
    color: ${SECONDARY};
  }

  @media screen and (max-width: 480px) {
    font-size: ${mobile_normal};
  }

  @media screen and (max-height: 690px) {
    font-size: 0.8rem;
    padding: 0.7rem 0.8rem;
  }
`;
